"use client";
import * as React from "react";
const SvgLightbulbFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.14 15.2c0 .4.32.8.79.8h3.14a.8.8 0 0 0 .79-.8v-.8H3.14zM5.5 0A5.5 5.5 0 0 0 0 5.6c0 1.92.94 3.6 2.36 4.56V12c0 .4.31.8.78.8h4.72a.8.8 0 0 0 .78-.8v-1.84A5.7 5.7 0 0 0 11 5.6C11 2.48 8.56 0 5.5 0" }));
export {
  SvgLightbulbFilled as default
};
